import React from 'react';
import { string, number, func, bool } from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';

const Start = ({
  title, description, image, altText, isMobile, currentQuestion, questionHandler
}) => {
  const descriptionClasses = classNames(
    'quiz-description', {
      'quiz-description--mobile': isMobile
    });
  return (
    <div className="sui-max-w-screen-2xl sui-m-auto intro-row">
      {isMobile
        ? (
          <>
            <h1 className="quiz-title">{title}</h1>
            <div className={`${descriptionClasses} sui-p-2`}>{description}</div>
            <div className="intro-image_wrapper sui-p-2">
              <img
                className="intro-image sui-w-full"
                src={image}
                alt={altText}
                height="200"
                width="300"
              />
            </div>
            <div className="intro-button sui-p-2">
              <Button variant="secondary" onClick={() => questionHandler(currentQuestion + 1)}>Get Started</Button>
            </div>
          </>
        )
        : (
          <div className="sui-grid sui-grid-cols-12 sui-p-2">
            <div className="intro-image_wrapper sui-grid sui-col-span-12 lg:sui-col-span-7">
              <img
                className="intro-image intro-image--space sui-w-full"
                src={image}
                alt={altText}
                height="300"
                width="500"
              />
            </div>
            <div className={`${descriptionClasses} sui-grid sui-col-span-12 lg:sui-col-span-5`}>
              <h1 className="quiz-title">{title}</h1>
              <p className={descriptionClasses}>{description}</p>
              <div className="intro-button">
                <Button
                  fullWidth
                  variant="secondary"
                  onClick={() => questionHandler(currentQuestion + 1)}
                >
                  Get Started
                </Button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

Start.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  image: string.isRequired,
  altText: string,
  isMobile: bool,
  currentQuestion: number,
  questionHandler: func
};

Start.defaultProps = {
  altText: '',
  isMobile: false,
  currentQuestion: -1,
  questionHandler: () => {}
};

export { Start };
